'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import NextImage, { ImageLoader } from 'next/image'
import { ComponentProps } from 'react'

/**
 * Uses the storyblok image service to optimize images
 * https://www.storyblok.com/docs/image-service/
 */
const storyblokImageLoader: ImageLoader = ({ src, width }) => {
  return `${src}/m/${width}x0/filters:quality(72)/`
}

export function StoryblokImage(
  props: Omit<ComponentProps<typeof NextImage>, 'loader'>,
) {
  return <NextImage loader={storyblokImageLoader} {...props} />
}
